export const ErrorLoggerToken = Symbol('ErrorLogger');
export const TrackingClientToken = Symbol('TrackingClient');
